/* Bag system — shared cart actions for the cart page and the drawer.

   Every action posts to the Cart AJAX API, then re-renders every
   [data-bag-root] on the page via the Section Rendering API (cart page
   section, drawer section, or both), updates the header count/total from
   the re-rendered root's data attributes, and keeps totals server-computed.

   window.refreshCart is overridden with the legacy contract intact: apps
   (Appstle et al.) call it after their own add-to-cart, expecting the
   drawer to refresh AND open. Internal actions re-render without opening.

   Also gives the cart drawer real focus management: focus moves in on
   open, returns to the trigger on close, and Tab cycles inside while open
   (the theme's inert list covers almost nothing). */

(function () {
  'use strict';
  if (window.__bagCartInit) return;
  window.__bagCartInit = true;

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-bag-root]'));
  }

  function busy(on) {
    roots().forEach(function (r) { r.classList.toggle('bag-is-busy', on); });
  }

  function rerender() {
    return Promise.all(roots().map(function (root) {
      var sid = root.getAttribute('data-bag-section');
      return fetch(window.location.pathname + '?section_id=' + sid)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-bag-root][data-bag-section="' + sid + '"]');
          if (next) root.replaceWith(next);
        });
    })).then(function () {
      var r0 = roots()[0];
      if (!r0) return;
      document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
        el.textContent = r0.getAttribute('data-bag-count');
      });
      document.querySelectorAll('[data-header-cart-total]').forEach(function (el) {
        el.textContent = r0.getAttribute('data-bag-total');
      });
      var sb = document.getElementById('site-cart-sidebar');
      if (sb) sb.classList.toggle('cart-is-empty', r0.getAttribute('data-bag-count') === '0');
      sweepPortalAttrs();
    });
  }

  /* Portal cart attributes must not survive into retail checkouts — the
     portal shares this browser cart, and an abandoned portal cart would
     otherwise hand its attributes to the next retail order (#41214).
     Strip only the attributes, only when present, only outside the portal:
     cart lines stay intact for a returning provider. */
  var portalAttrsSwept = false;
  function sweepPortalAttrs() {
    if (portalAttrsSwept) return;
    if (window.location.pathname.indexOf('/apps/portal') === 0) return;
    var r0 = roots()[0];
    if (!r0 || r0.getAttribute('data-bag-portal-attrs') !== '1') return;
    portalAttrsSwept = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { bsk_source: null, ship_to_patient: null, ship_to_patient_name: null } })
    }).catch(function () {});
  }

  function post(url, body) {
    busy(true);
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('cart request failed');
      return res.json();
    }).then(function (d) {
      return rerender().then(function () { busy(false); return d; });
    }).catch(function () {
      busy(false);
    });
  }

  document.addEventListener('click', function (e) {
    var el;

    el = e.target.closest('#site-cart-sidebar [data-js-close]');
    if (el) {
      var sb = document.getElementById('site-cart-sidebar');
      if (sb && typeof sb.hide === 'function') sb.hide();
      return;
    }

    el = e.target.closest('[data-bag-qty]');
    if (el) {
      var next = Math.max(1, parseInt(el.getAttribute('data-current'), 10) + parseInt(el.getAttribute('data-bag-qty'), 10));
      post('/cart/change.js', { line: parseInt(el.getAttribute('data-line'), 10), quantity: next });
      return;
    }

    el = e.target.closest('[data-bag-rm]');
    if (el) {
      e.preventDefault();
      post('/cart/change.js', { line: parseInt(el.getAttribute('data-line'), 10), quantity: 0 });
      return;
    }

    el = e.target.closest('[data-bag-clear]');
    if (el) {
      post('/cart/clear.js', {});
      return;
    }

    el = e.target.closest('[data-bag-switch]');
    if (el) {
      var plan = el.getAttribute('data-plan');
      post('/cart/change.js', {
        line: parseInt(el.getAttribute('data-line'), 10),
        selling_plan: plan ? parseInt(plan, 10) : null
      });
      return;
    }

    el = e.target.closest('[data-bag-chip]');
    if (el && !el.disabled) {
      post('/cart/add.js', { id: parseInt(el.getAttribute('data-bag-chip'), 10), quantity: 1 });
      return;
    }

    el = e.target.closest('[data-bag-ritual]');
    if (el) {
      post('/cart/add.js', { id: parseInt(el.getAttribute('data-bag-ritual'), 10), quantity: 1 });
      return;
    }

    el = e.target.closest('[data-bag-bundleswap]');
    if (el) {
      var updates = {};
      (el.getAttribute('data-components') || '').split(',').forEach(function (vid) {
        if (vid) updates[vid] = 0;
      });
      busy(true);
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (res) { return res.json(); }).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(el.getAttribute('data-bag-bundleswap'), 10), quantity: 1 })
        });
      }).then(function () { return rerender(); }).then(function () { busy(false); })
        .catch(function () { busy(false); });
    }
  });

  /* legacy contract: apps call window.refreshCart() after their own add —
     refresh everything and open the drawer */
  window.refreshCart = function () {
    rerender().then(function () {
      var sb = document.getElementById('site-cart-sidebar');
      if (sb && typeof sb.show === 'function' && !sb.classList.contains('sidebar--opened')) {
        sb.show();
      }
    });
  };

  /* focus management for the drawer */
  function patchDrawer() {
    var sb = document.getElementById('site-cart-sidebar');
    if (!sb || sb.__bagPatched || typeof sb.show !== 'function') return;
    sb.__bagPatched = true;
    var origShow = sb.show.bind(sb);
    var origHide = sb.hide.bind(sb);
    sb.show = function () {
      window.__bagLastFocus = document.activeElement;
      origShow();
      setTimeout(function () { sb.focus(); }, 40);
    };
    sb.hide = function () {
      origHide();
      if (window.__bagLastFocus && typeof window.__bagLastFocus.focus === 'function') {
        window.__bagLastFocus.focus();
      }
    };
    sb.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !sb.classList.contains('sidebar--opened')) return;
      var f = sb.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === sb)) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('sidebar-drawer').then(function () { setTimeout(patchDrawer, 0); });
  }
  if (document.readyState !== 'loading') setTimeout(patchDrawer, 500);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(patchDrawer, 500); });

  /* persistent mobile checkout bar on the cart page: reveal once the main
     checkout button scrolls out of view; reserve bottom space so it never
     covers the trust line. CSS keeps it hidden above the mobile breakpoint. */
  function initStickyBar() {
    var bar = document.querySelector('[data-crt-sticky]');
    var mainBtn = document.querySelector('.crt-checkout');
    var scope = document.querySelector('.crt-scope');
    if (!bar || !mainBtn || !scope || !('IntersectionObserver' in window)) return;
    scope.classList.add('crt-has-stickybar');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.hidden = e.isIntersecting; });
    }, { rootMargin: '0px 0px -40px 0px' });
    io.observe(mainBtn);
  }
  if (document.readyState !== 'loading') initStickyBar();
  else document.addEventListener('DOMContentLoaded', initStickyBar);

  if (document.readyState !== 'loading') sweepPortalAttrs();
  else document.addEventListener('DOMContentLoaded', sweepPortalAttrs);
})();